import { Reducer } from 'redux'
import { IToolsMenuInfo, ToolsMenuInfoType } from './types'

const INITIAL_STATE = {
  infoViewed: false,
}

const reducer: Reducer<IToolsMenuInfo> = (state: IToolsMenuInfo = INITIAL_STATE, action) => {
  switch (action.type) {
    case ToolsMenuInfoType.SET_INFO_VIEW_STATUS: {
      return { infoViewed: action.payload }
    }

    default:
      return state
  }
}

export default reducer
